// Restoran logini (Q-021): har bir yangi qurilma (kassa, oshxona ekrani, ega telefoni) bir marta
// restoran logini va paroli bilan kiradi va eslab qolinadi. Keyin — faqat PIN.
import { useState } from 'react';
import type { FormEvent } from 'react';
import { Alert, BrandLockup, BrandMark, Button, Icon, TextField } from '@onepos/ui';
import { useKassa } from '../kassa/store';
import { supportUrl } from '../lib/support';

export function LoginPage() {
  const { loginRestaurant, message, sync } = useKassa();
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (login.trim().length < 3 || !password) {
      setError('Restoran logini va parolni kiriting.');
      return;
    }
    setBusy(true);
    setError(undefined);
    try {
      await loginRestaurant(login, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  };

  return (
    <div className="cn-login">
      <section className="cn-login__brand" aria-hidden="true">
        <BrandMark size={520} tone="white" simple={false} className="cn-login__water" />
        <BrandLockup height={52} tone="white" title="ONE POS" />
        <div>
          <p className="cn-login__lead">Restoraningiz — qo‘lingizda.</p>
          <ul className="cn-login__points">
            <li>
              <Icon name="device" /> Qurilma bir marta ulanadi — keyin faqat PIN
            </li>
            <li>
              <Icon name="users" /> Har bir xodim o‘z PIN kodi bilan
            </li>
            <li>
              <Icon name="shield" /> Kim, qachon, nima qilgani — jurnalda
            </li>
          </ul>
        </div>
        <span className="cn-login__foot">app.onepos.uz</span>
      </section>
      <section className="cn-login__form-wrap">
        <form className="cn-login__form" onSubmit={(e) => void submit(e)} noValidate>
          <div>
            <h1 className="cn-login__title">Restoranga kirish</h1>
            <p className="cn-muted">ONE POS bergan restoran logini va paroli. Bu qurilmada bir marta kiritiladi.</p>
          </div>
          {(error ?? message) && <Alert tone={error ? 'danger' : 'warning'}>{error ?? message}</Alert>}
          {sync.pending > 0 && (
            <Alert tone="info">Bu qurilmada hali yuborilmagan {sync.pending} ta amal bor — kirgandan keyin yuboriladi.</Alert>
          )}
          <TextField
            label="Restoran logini"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            placeholder="masalan, lavash-markaz"
            autoFocus
          />
          <div className="cn-pw">
            <TextField
              label="Parol"
              type={show ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="cn-pw__toggle"
              aria-label={show ? 'Parolni yashirish' : 'Parolni ko‘rsatish'}
              aria-pressed={show}
              onClick={() => setShow((v) => !v)}
            >
              <Icon name="eye" />
            </button>
          </div>
          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? 'Tekshirilmoqda…' : 'Kirish'}
          </Button>
          <p className="cn-muted" style={{ fontSize: 13 }}>
            Login yoki parolni bilmaysizmi? Restoran egasidan so‘rang yoki ONE POS yordamiga yozing.
          </p>
          <a className="cn-login__help" href={supportUrl()} target="_blank" rel="noopener noreferrer">
            <Icon name="send" /> Telegram’da yordam so‘rash
          </a>
        </form>
      </section>
    </div>
  );
}
